<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h13">Glossario</h1>
<p class="p6"><img alt="img3.png" src="Images/img3.png"/></p>
<p> </p>
<p class="p8"><span class="t5">Aker</span></p>
<p class="p9">Una posizione di comando in una grande tribù, molto ambita. Risponde direttamente al mahees. Gli Aker sono sempre nominati in coppia: un manu e un bakhu.</p>
<p class="p8"><span class="t5">Amenta</span></p>
<p class="p9">Una pantera che vive senza permesso sul territorio di una tribù non sua.</p>
<p class="p8"><span class="t5">Aset</span></p>
<p class="p9">La compagna predestinata di un semel in caso di morte della sua reah. Una aset può solo essere scelta, designata, da una reah.</p>
<p class="p8"><span class="t5">Beset</span></p>
<p class="p9">L’accompagnatore di una reah.</p>
<p class="p8"><span class="t5">Duat</span></p>
<p class="p9">Una pantera che ha promesso, pena la morte, di vivere per sempre come umano, senza mai trasformarsi.</p>
<p class="p8"><span class="t5">Khatyu</span></p>
<p class="p9">I soldati di un semel.</p>
<p class="p8"><span class="t5">Maahes</span></p>
<p class="p9">Il principe di una tribù, emissario del semel</p>
<p class="p8"><span class="t5">Mastaba</span></p>
<p class="p9">La signora della casa di un semel, solitamente la vedova del semel precedente.</p>
<p class="p8"><span class="t6">Maat</span></p>
<p class="p9">Equilibrio, armonia, azione corretta.</p>
<p class="p8"><span class="t5">Phocal</span></p>
<p class="p9">Capo dei felini Shu, un gruppo elitario di pantere mannare che servono il Sacerdote di Chae Rophon.</p>
<p class="p8"><span class="t5">Reah</span></p>
<p class="p9">La vera compagna di un semel.</p>
<p class="p8"><span class="t5">Semel</span></p>
<p class="p9">Il capotribù.</p>
<p class="p8"><span class="t5">Semel-aten</span></p>
<p class="p9">Capotribù della città di Sobek, capitale delle pantere mannare.</p>
<p class="p8"><span class="t5">Semel-re</span></p>
<p class="p9">Capotribù che ha avuto la benedizione di trovare la sua vera compagna, un capo che ha trovato la sua reah.</p>
<p class="p8"><span class="t5">Sepat</span></p>
<p class="p9">Una sfida d’onore.</p>
<p class="p8"><span class="t5">Sheseran</span></p>
<p class="p9">Compagna di uno sheseru.</p>
<p class="p8"><span class="t5">Sheseru</span></p>
<p class="p9">(Frusta) Sceriffo della tribù, guardiano della compagna del semel.</p>
<p class="p8"><span class="t5">Sylvan</span></p>
<p class="p9">(Bastone) Saggio della tribù, consigliere del semel.</p>
<p class="p8"><span class="t5">Taurth</span></p>
<p class="p9">Una yareah che è stata messa da parte perché un semel ha trovato la sua vera compagna.</p>
<p class="p8"><span class="t5">Wosret</span></p>
<p class="p9">Una reah senza compagno rivendicata dal semel-aten come concubina.</p>
<p class="p8"><span class="t5">Yareah</span></p>
<p class="p9">La compagna di un semel che è stata scelta; non la sua vera compagna.</p>
<p class="p10"><span class="t3"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?c148adc8